import React from 'react';

const Footer = () => {
    return (
        <footer className="footer">
            <span className="pull-right">
                GrowBizh - Empowering Your Business Dreams
            </span>
            Company 2025
        </footer>
    );
}

export default Footer;